import {
  GET_APPROVED_FINANCIAL_AID,
  GET_APPROVED_FINANCIAL_AID_SUCCESS,
  GET_APPROVED_FINANCIAL_AID_FAIL,
  FINANCIAL_AID_DETAILS,
  FINANCIAL_AID_DETAILS_SUCCESS,
  FINANCIAL_AID_DETAILS_FAIL,
  GET_FA_APT_DETAILS,
  GET_FA_APT_DETAILS_SUCCESS,
  GET_FA_APT_DETAILS_FAIL,
  GET_ALL_DONATIONS,
  DONATION_TOTAL,
  DONATION_TOTAL_FAIL,
  DONATION_TOTAL_SUCCESS,
  GET_ALL_DONATIONS_FAIL,
  GET_ALL_DONATIONS_SUCCESS,
} from "./actionTypes";

import {
  getPendingFinancialAid,
  getPendingFinancialAidSuccess,
  getPendingFinancialAidFail,
  getApprovedFinancialAid,
  getApprovedFinancialAidSuccess,
  getApprovedFinancialAidFail,
  acceptFinancialAid,
  acceptFinancialAidSuccess,
  acceptFinancialAidFail,
  rejectFinancialAid,
  rejectFinancialAidSuccess,
  rejectFinancialAidFail,
  financialAidDetails,
  financialAidDetailsSuccess,
  financialAidDetailsFail,
  getFAAptDetails,
  getFAAptDetailsSuccess,
  getFAAptDetailsFail,
  getAllDonationsFail,
  getAllDonationsSuccess,
  donationTotalSuccess,
  donationTotalFail,
} from "./actions";
import { takeEvery, put, call } from "redux-saga/effects";
import axios from "axios";
import toast from "react-hot-toast";
import { url } from "APIs/URLS";

export const getPendingFADetailsAPI = async id => {
  try {
    // console.log("token in saga", token);
    const response = await axios.get(`${url}/Finance/FADetails/${id}`);
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* PendingFinancialAidDetails({ payload: id }) {
  try {
    const response = yield call(getPendingFADetailsAPI, id);
    console.log("pendingFADetails", response);
    yield put(financialAidDetailsSuccess(response));
  } catch (error) {
    yield put(financialAidDetailsFail(error));
  }
}

//Financial Aid Appointment Details
export const getFAAptDetailsAPI = async id => {
  try {
    // console.log("token in saga", token);
    const response = await axios.get(
      `${url}/Appointments/getappointmentdetails/${id}`
    );
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* FAAptDetails({ payload: id }) {
  try {
    const response = yield call(getFAAptDetailsAPI, id);
    console.log("getFAAptDetails", response);
    yield put(getFAAptDetailsSuccess(response));
  } catch (error) {
    yield put(getFAAptDetailsFail(error));
  }
}

////////////////////GET APPROVED FINANCIAL AID LIST////////////////////////
export const getApprovedFAAPI = async () => {
  try {
    // console.log("token in saga", token);
    const response = await axios.get(`${url}/Finance/approvedFAs`);
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* ApprovedFinancialAid() {
  try {
    const response = yield call(getApprovedFAAPI);
    console.log("approvedFA", response);
    yield put(getApprovedFinancialAidSuccess(response));
  } catch (error) {
    yield put(getApprovedFinancialAidFail(error));
  }
}

export const getAllDonationsAPI = async () => {
  try {
    // console.log("token in saga", token);
    const response = await axios.get(`${url}/Finance/getdonations`);
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* getAllDonationsfun() {
  try {
    const response = yield call(getAllDonationsAPI);
    console.log("donations", response);
    yield put(getAllDonationsSuccess(response));
  } catch (error) {
    yield put(getAllDonationsFail(error));
  }
}

export const totaldonationsAPI = async () => {
  try {
    // console.log("token in saga", token);
    const response = await axios.get(`${url}/Finance/getTotalDonations`);
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* totaldonationsfun() {
  try {
    const response = yield call(totaldonationsAPI);
    console.log("totaldonations", response);
    yield put(donationTotalSuccess(response));
  } catch (error) {
    yield put(donationTotalFail(error));
  }
}

function* AdminFinancialAidSaga() {
  yield takeEvery(FINANCIAL_AID_DETAILS, PendingFinancialAidDetails);

  yield takeEvery(GET_FA_APT_DETAILS, FAAptDetails);
  yield takeEvery(GET_APPROVED_FINANCIAL_AID, ApprovedFinancialAid);
  yield takeEvery(GET_ALL_DONATIONS, getAllDonationsfun);
  yield takeEvery(DONATION_TOTAL, totaldonationsfun);
}

export default AdminFinancialAidSaga;
